/** Layout explainer copy + simulated CI sidebar for AdvancedTUIDemo. */
// Simulated TUI data
export const ADVANCED_TUI_SIDEBAR_ITEMS = [
  { id: 'deploy-1', name: 'how-terminals-verify', status: 'success' },
  { id: 'deploy-2', name: 'hitaarthh.com-lighthouse', status: 'running' },
  { id: 'deploy-3', name: 'golden-hour-roll-sync', status: 'success' },
  { id: 'deploy-4', name: 'py-insights-smoke', status: 'failed' },
  { id: 'deploy-5', name: 'vercel-prod-waiting', status: 'pending' },
];

export const ADVANCED_TUI_TABS = ['Ship', 'Measure', 'Logs'];

export type AdvancedTuiExplainerStep =
  | 'overview'
  | 'layout-system'
  | 'focus-management'
  | 'resize-handling'
  | 'rendering';

export interface AdvancedTuiExplainerSlide {
  title: string;
  description: string;
  highlightRegions: string[];
}

export const ADVANCED_TUI_EXPLAINER_STEPS: Record<
  AdvancedTuiExplainerStep,
  AdvancedTuiExplainerSlide
> = {
  overview: {
    title: 'The Layout System',
    description:
      "Advanced TUIs divide the terminal into regions. Each region is a rectangular area with its own content and borders. The TUI framework tracks each region's position and size in the character grid.",
    highlightRegions: ['tabs', 'sidebar', 'content'],
  },
  'layout-system': {
    title: 'Region Coordinates',
    description:
      'Each region stores its position (x, y) and dimensions (width, height) in character cells. Box-drawing characters (like ┌─┐│) create visual borders. The TUI recalculates these when content changes.',
    highlightRegions: [],
  },
  'focus-management': {
    title: 'Focus & Input Routing',
    description:
      "Only one region is 'focused' at a time (shown with a green border). Keystrokes are routed to the focused region. Tab/arrow keys move focus between regions. The cursor position is tracked within the focused region.",
    highlightRegions: ['sidebar'],
  },
  'resize-handling': {
    title: 'Terminal Resize',
    description:
      "When you resize the terminal window, it sends a SIGWINCH signal. The TUI queries the new size with ioctl(), then recalculates every region's dimensions and re-renders the entire screen.",
    highlightRegions: [],
  },
  rendering: {
    title: 'Full-Screen Rendering',
    description:
      "TUIs often use 'alternate screen mode' (CSI ?1049h) for a clean canvas. They position the cursor with escape codes and draw each cell. Double-buffering prevents flicker: draw to memory first, then output all at once.",
    highlightRegions: [],
  },
};
